module.exports = __webpack_public_path__ + "img/03_ic_angle_black_62px.d3bc53b3.svg";